var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        gray: _vm.paywallPlans.annualPlanIsTrialPlan
      }
    },
    [
      _c(
        "div",
        {
          class: [
            "plans-section",
            "paywall",
            { mobile: _vm.isMobile(_vm.$mq) }
          ],
          attrs: { name: "paywall-header" }
        },
        [
          _c("div", { staticClass: "content" }, [
            _c("header", { attrs: { "data-testid": "paywall_plans_header" } }, [
              _vm.user.is_during_trial
                ? _c("h2", [_vm._v("You're on a free trial")])
                : _vm.paywallPlans.annualPlanIsTrialPlan
                ? _c("h2", [
                    _vm._v(
                      "\n          Start your " +
                        _vm._s(_vm.trialLength) +
                        "-day free trial\n        "
                    )
                  ])
                : _vm.upgrade && _vm.paywallPlans.annualPlan
                ? _c("h2", [
                    _vm._v(
                      "\n          Switch to annual and save " +
                        _vm._s(_vm.paywallPlans.annualPlan.saving_percentage) +
                        "%\n        "
                    )
                  ])
                : _vm.upgrade && _vm.paywallPlans.lifetimePlan
                ? _c("h2", [_vm._v("Switch to lifetime")])
                : _vm.alreadyLifetime
                ? _c("h2", [_vm._v("You're already a Lifetime member")])
                : _c("h2", [_vm._v("Unlock the full Brilliant experience")]),
              _vm._v(" "),
              _vm.upgrade &&
              !_vm.paywallPlans.annualPlan &&
              _vm.paywallPlans.lifetimePlan
                ? _c("h3", [
                    _vm._v(
                      "\n          Don't want to fuss around with subscriptions? Get Brilliant Premium forever.\n        "
                    )
                  ])
                : _vm.alreadyLifetime
                ? _c("h3", [
                    _vm._v(
                      "\n          You have access to all of Brilliant's content for life. Thank you for your support!\n        "
                    )
                  ])
                : !_vm.upgrade
                ? _c("h3", [
                    _vm._v(
                      "\n          Get unlimited access to all math, science, and computer science courses on Brilliant."
                    ),
                    _c("br")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.shouldShowDiscount
                ? _c(
                    "p",
                    {
                      attrs: { "data-testid": "paywall_plans_header_discount" }
                    },
                    [
                      _c("span", { staticClass: "b-sprite-paywall-lightning" }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.discountHtml) }
                      })
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.paywallPlans.annualPlanIsTrialPlan || _vm.user.is_during_trial
              ? _c("div", { staticClass: "trial" }, [
                  _vm.user.is_during_trial
                    ? _c(
                        "button",
                        {
                          staticClass: "btn trial-active",
                          attrs: { disabled: "" }
                        },
                        [_vm._v("\n          You're on your trial\n        ")]
                      )
                    : _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "track",
                              rawName: "v-track:click",
                              value: {
                                axId:
                                  "clicked_nux_paywall_subscribe_free_trial_annual"
                              },
                              expression:
                                "{\n            axId: 'clicked_nux_paywall_subscribe_free_trial_annual',\n          }",
                              arg: "click"
                            }
                          ],
                          staticClass: "btn btn-green",
                          attrs: {
                            "data-testid": "paywall_plans_cta_button",
                            "data-price-vendor":
                              _vm.paywallPlans.annualPlan.price_vendor
                          },
                          on: { click: _vm.handleAnnualClick }
                        },
                        [
                          [
                            _vm._v(
                              " Get " + _vm._s(_vm.trialLength) + " days free "
                            )
                          ]
                        ],
                        2
                      ),
                  _vm._v(" "),
                  _vm.paywallPlans.annualPlan
                    ? _c("p", [
                        _vm.strikeThroughPrice
                          ? _c("s", [
                              _vm._v(
                                _vm._s(
                                  _vm.paywallPlans.annualPlan
                                    .strikethrough_price
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.experimentAwareTrialPlanPriceMessage) +
                            "\n          "
                        ),
                        _vm.paywallPlans.annualPlanDirect
                          ? _c("span", [
                              _vm._v("\n            Or\n            "),
                              _c(
                                "span",
                                {
                                  staticClass: "subscribe-today",
                                  attrs: {
                                    "data-price-vendor":
                                      _vm.paywallPlans.annualPlanDirect
                                        .price_vendor
                                  },
                                  on: { click: _vm.handleSubscribeNowClick }
                                },
                                [
                                  _vm._v(
                                    "\n              subscribe today.\n            "
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              : _c(
                  "div",
                  { staticClass: "plans" },
                  [
                    _vm.monthlyPlan && !_vm.isMobileViewPort
                      ? _c(
                          "div",
                          {
                            staticClass: "plan",
                            class: {
                              popular: _vm.paywallPlans.monthlyPlan.is_popular
                            },
                            attrs: {
                              "data-price-vendor":
                                _vm.paywallPlans.monthlyPlan.price_vendor
                            }
                          },
                          [
                            _c("h4", [_vm._v("Monthly")]),
                            _vm._v(" "),
                            _c("div", [
                              _c("h5", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.monthlyPlan.display_price) +
                                    "\n              "
                                ),
                                _c("small", [_vm._v("/month")])
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "track",
                                      rawName: "v-track:click",
                                      value: { axId: _vm.axId("monthly") },
                                      expression: "{ axId: axId('monthly') }",
                                      arg: "click"
                                    }
                                  ],
                                  staticClass: "btn btn-green",
                                  on: { click: _vm.handleMonthlyClick }
                                },
                                [
                                  _vm._v(
                                    "\n              Subscribe now\n            "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm.monthlyPlan && _vm.isMobileViewPort
                      ? _c(
                          "PaywallPlanMini",
                          {
                            attrs: {
                              axId: _vm.axId("monthly"),
                              "data-price-vendor":
                                _vm.paywallPlans.monthlyPlan.price_vendor
                            },
                            on: { "plan-clicked": _vm.handleMonthlyClick }
                          },
                          [
                            _c(
                              "h4",
                              {
                                attrs: { slot: "plan-name" },
                                slot: "plan-name"
                              },
                              [_vm._v("Monthly")]
                            ),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                attrs: { slot: "plan-price" },
                                slot: "plan-price"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.monthlyPlan.display_price) +
                                    "\n            "
                                ),
                                _c("small", [_vm._v("/month")])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.paywallPlans.threeMonthPlan
                      ? _c("PaywallPlan", {
                          class: {
                            popular: _vm.paywallPlans.threeMonthPlan.is_popular
                          },
                          attrs: {
                            plan: _vm.paywallPlans.threeMonthPlan,
                            upgrade: _vm.upgrade
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.paywallPlans.sixMonthPlan
                      ? _c("PaywallPlan", {
                          class: {
                            popular: _vm.paywallPlans.sixMonthPlan.is_popular
                          },
                          attrs: {
                            plan: _vm.paywallPlans.sixMonthPlan,
                            upgrade: _vm.upgrade
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.paywallPlans.annualPlan && !_vm.isMobileViewPort
                      ? _c(
                          "div",
                          {
                            staticClass: "plan",
                            class: {
                              popular: _vm.paywallPlans.annualPlan.is_popular
                            },
                            attrs: {
                              "data-price-vendor":
                                _vm.paywallPlans.annualPlan.price_vendor
                            }
                          },
                          [
                            _c("h4", [_vm._v("Annual")]),
                            _vm._v(" "),
                            _c("div", [
                              _c("h5", [
                                _vm.strikeThroughPrice
                                  ? _c("s", { staticClass: "original" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.paywallPlans.annualPlan
                                            .strikethrough_price
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.paywallPlans.annualPlan.display_price
                                    ) +
                                    "\n              "
                                ),
                                _c("small", [_vm._v("/month*")])
                              ]),
                              _vm._v(" "),
                              _vm.paywallPlans.annualPlan.renewal_price &&
                              !_vm.paywallPlans
                                .annualPlanIncludesReferralDiscount
                                ? _c("span", [
                                    _c("small", [
                                      _vm._v(
                                        "for the first year, then\n                " +
                                          _vm._s(
                                            _vm.paywallPlans.annualPlan
                                              .renewal_price
                                          ) +
                                          "/month*"
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "track",
                                      rawName: "v-track:click",
                                      value: { axId: _vm.axId("annual") },
                                      expression: "{ axId: axId('annual') }",
                                      arg: "click"
                                    }
                                  ],
                                  staticClass: "btn btn-green",
                                  on: { click: _vm.handleAnnualClick }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.upgrade
                                          ? "Switch to annual"
                                          : "Subscribe now"
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm.paywallPlans.annualPlan && _vm.isMobileViewPort
                      ? _c(
                          "PaywallPlanMini",
                          {
                            class: {
                              popular: _vm.paywallPlans.annualPlan.is_popular
                            },
                            attrs: {
                              axId: _vm.axId("annual"),
                              "data-price-vendor":
                                _vm.paywallPlans.annualPlan.price_vendor
                            },
                            on: { "plan-clicked": _vm.handleAnnualClick }
                          },
                          [
                            _c(
                              "h4",
                              {
                                attrs: { slot: "plan-name" },
                                slot: "plan-name"
                              },
                              [_vm._v("Annual")]
                            ),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                attrs: { slot: "plan-price" },
                                slot: "plan-price"
                              },
                              [
                                _vm.strikeThroughPrice
                                  ? _c("s", { staticClass: "original" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.paywallPlans.annualPlan
                                            .strikethrough_price
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.paywallPlans.annualPlan.display_price
                                    ) +
                                    "\n            "
                                ),
                                _c("small", [_vm._v("/month*")])
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.paywallPlans.twoYearPlan
                      ? _c("PaywallPlan", {
                          class: {
                            popular: _vm.paywallPlans.twoYearPlan.is_popular
                          },
                          attrs: {
                            plan: _vm.paywallPlans.twoYearPlan,
                            upgrade: _vm.upgrade
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.paywallPlans.threeYearPlan
                      ? _c("PaywallPlan", {
                          class: {
                            popular: _vm.paywallPlans.threeYearPlan.is_popular
                          },
                          attrs: {
                            plan: _vm.paywallPlans.threeYearPlan,
                            upgrade: _vm.upgrade
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.paywallPlans.fourYearPlan
                      ? _c("PaywallPlan", {
                          class: {
                            popular: _vm.paywallPlans.fourYearPlan.is_popular
                          },
                          attrs: {
                            plan: _vm.paywallPlans.fourYearPlan,
                            upgrade: _vm.upgrade
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.paywallPlans.groupPlan && !_vm.isMobileViewPort
                      ? _c(
                          "div",
                          {
                            staticClass: "plan",
                            attrs: {
                              "data-price-vendor":
                                _vm.paywallPlans.groupPlan.price_vendor
                            }
                          },
                          [
                            _c("h4", [_vm._v("Groups of 3+")]),
                            _vm._v(" "),
                            _c("div", [
                              _c("h5", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.paywallPlans.groupPlan.display_price
                                    ) +
                                    "\n              "
                                ),
                                _c("small", [_vm._v("/year")])
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "track",
                                      rawName: "v-track:click",
                                      value: {
                                        axId: "clicked_pay_button_groups",
                                        axType: "button"
                                      },
                                      expression:
                                        "{\n                axId: 'clicked_pay_button_groups',\n                axType: 'button',\n              }",
                                      arg: "click"
                                    }
                                  ],
                                  staticClass: "btn btn-green",
                                  attrs: {
                                    href:
                                      _vm.paywallPlans.groupPlan.checkout_url
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Subscribe now\n            "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm.paywallPlans.groupPlan && _vm.isMobileViewPort
                      ? _c(
                          "PaywallPlanMini",
                          {
                            attrs: {
                              axId: "clicked_pay_button_groups",
                              "data-price-vendor":
                                _vm.paywallPlans.groupPlan.price_vendor,
                              checkoutUrl:
                                _vm.paywallPlans.groupPlan.checkout_url
                            }
                          },
                          [
                            _c(
                              "h4",
                              {
                                attrs: { slot: "plan-name" },
                                slot: "plan-name"
                              },
                              [_vm._v("Groups of 3+")]
                            ),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                attrs: { slot: "plan-price" },
                                slot: "plan-price"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.paywallPlans.groupPlan.display_price
                                    ) +
                                    "\n            "
                                ),
                                _c("small", [_vm._v("/year")])
                              ]
                            )
                          ]
                        )
                      : _vm.paywallPlans.lifetimePlan && !_vm.isMobileViewPort
                      ? _c(
                          "div",
                          {
                            staticClass: "plan",
                            class: {
                              popular: _vm.paywallPlans.lifetimePlan.is_popular
                            },
                            attrs: {
                              "data-price-vendor":
                                _vm.paywallPlans.lifetimePlan.price_vendor
                            }
                          },
                          [
                            _c("h4", [_vm._v("Lifetime")]),
                            _vm._v(" "),
                            _c("div", [
                              _c("h5", [
                                _vm.strikeThroughPrice
                                  ? _c("s", { staticClass: "original" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.paywallPlans.lifetimePlan
                                            .strikethrough_price
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.paywallPlans.lifetimePlan
                                        .display_price
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "track",
                                      rawName: "v-track:click",
                                      value: { axId: _vm.axId("lifetime") },
                                      expression: "{ axId: axId('lifetime') }",
                                      arg: "click"
                                    }
                                  ],
                                  staticClass: "btn btn-green",
                                  on: { click: _vm.handleLifetimeClick }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.upgrade
                                          ? "Switch to lifetime"
                                          : "Subscribe now"
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm.paywallPlans.lifetimePlan && _vm.isMobileViewPort
                      ? _c(
                          "PaywallPlanMini",
                          {
                            class: {
                              popular: _vm.paywallPlans.lifetimePlan.is_popular
                            },
                            attrs: {
                              axId: _vm.axId("lifetime"),
                              "data-price-vendor":
                                _vm.paywallPlans.lifetimePlan.price_vendor
                            },
                            on: { "plan-clicked": _vm.handleLifetimeClick }
                          },
                          [
                            _c(
                              "h4",
                              {
                                attrs: { slot: "plan-name" },
                                slot: "plan-name"
                              },
                              [_vm._v("Lifetime")]
                            ),
                            _vm._v(" "),
                            _c(
                              "h5",
                              {
                                attrs: { slot: "plan-price" },
                                slot: "plan-price"
                              },
                              [
                                _vm.strikeThroughPrice
                                  ? _c("s", { staticClass: "original" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.paywallPlans.lifetimePlan
                                            .strikethrough_price
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.paywallPlans.lifetimePlan
                                        .display_price
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
            _vm._v(" "),
            _vm.showOnePaymentWarning
              ? _c("div", { staticClass: "legal" }, [
                  _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.onePaymentWarning) +
                        "\n          "
                    ),
                    !(
                      _vm.paywallPlans.annualPlanIncludesReferralDiscount &&
                      _vm.paywallPlans.annualPlanIsTrialPlan
                    )
                      ? _c(
                          "button",
                          {
                            staticClass: "btn-link",
                            on: {
                              click: function($event) {
                                _vm.showLegal = true
                              }
                            }
                          },
                          [_vm._v("\n            here.\n          ")]
                        )
                      : _vm._e()
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.showLegal
            ? _c("PaywallSubscriptionNotice", {
                on: {
                  close: function($event) {
                    _vm.showLegal = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.user.is_during_trial
        ? _c(
            "div",
            { staticClass: "premium-trial-settings" },
            [
              _vm._v("\n    Manage your trial settings\n    "),
              _c(
                "router-link",
                { attrs: { to: { name: "payment_subscription_settings" } } },
                [_vm._v("here")]
              ),
              _vm._v(".\n  ")
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }